module.exports = __webpack_public_path__ + "assets/img/yutariya.2cba4416.svg";